import { fontFamilyVariable } from '@cronos-app/chakra';
import { Global } from '@emotion/react';
import { Archivo } from 'next/font/google';

const archivo = Archivo({
  subsets: ['latin'],
  display: 'swap',
  weight: ['300', '400', '500', '700'],
  preload: true,
});

export const Fonts = () => {
  return (
    <Global
      styles={`
      :root {
        ${fontFamilyVariable.default}: ${archivo.style.fontFamily};
        ${fontFamilyVariable.heading}: ${archivo.style.fontFamily};
      }
    `}
    />
  );
};
